import React from 'react';

/** app2026 편성표 하단 안내 (라이브엔드·전체편성표 공통 마크업) */
export default function ScheduleInfoDott() {
  return (
    <ul className="schedule_info_dott">
      <li>본 편성표는 방송사 사정에 따라 변경 될 수 있습니다.</li>
      <li>TV 다시보기 동영상은 방송 종료 후 업데이트 됩니다.</li>
      <li>
        프로그램별/서비스별로 과금이 상이 하므로 결제 전 과금 정보를 반드시 확인
        하세요.
      </li>
    </ul>
  );
}
